export const SUPPORTED_LANGUAGES = ["en", "pt", "es", "ru", "tr"];

export const LANGUAGE_LABELS = {
    en: "English",
    pt: "Português",
    es: "Español",
    ru: "Русский",
    tr: "Türkçe",
};

export const COPY = {
    navbar: {
        platforms: {
            en: "Platforms",
            pt: "Plataformas",
            es: "Plataformas",
            ru: "Платформы",
            tr: "Platformlar",
        },
        volumeRewards: {
            en: "Volume Rewards",
            pt: "Recompensas por Volume",
            es: "Recompensas por Volumen",
            ru: "Награды за объём",
            tr: "Hacim Ödülleri",
        },
        pricing: {
            en: "Pricing",
            pt: "Preços",
            es: "Precios",
            ru: "Тарифы",
            tr: "Fiyatlar",
        },
        resources: {
            en: "Resources",
            pt: "Recursos",
            es: "Recursos",
            ru: "Ресурсы",
            tr: "Kaynaklar",
        },
        faq: {
            en: "FAQ",
            pt: "FAQ",
            es: "FAQ",
            ru: "FAQ",
            tr: "SSS",
        },
        signIn: {
            en: "Sign in",
            pt: "Entrar",
            es: "Iniciar sesión",
            ru: "Войти",
            tr: "Giriş yap",
        },
        apply: {
            en: "Apply Free",
            pt: "Solicitar Grátis",
            es: "Solicitar Gratis",
            ru: "Бесплатная заявка",
            tr: "Ücretsiz Başvur",
        },
        menu: {
            en: "Menu",
            pt: "Menu",
            es: "Menú",
            ru: "Меню",
            tr: "Menü",
        },
        language: {
            en: "Language",
            pt: "Idioma",
            es: "Idioma",
            ru: "Язык",
            tr: "Dil",
        },
        allAccessTitle: {
            en: "All platforms included",
            pt: "Todas as plataformas incluídas",
            es: "Todas las plataformas incluidas",
            ru: "Все платформы включены",
            tr: "Tüm platformlar dahil",
        },
        allAccessHint: {
            en: "No subscription · volumetric top-up fee only",
            pt: "Sem assinatura · apenas taxa de recarga volumétrica",
            es: "Sin suscripción · solo comisión de recarga volumétrica",
            ru: "Без подписки · только комиссия за пополнение",
            tr: "Abonelik yok · sadece hacme göre yükleme komisyonu",
        },
    },
    auth: {
        loginTitle: {
            en: "Sign in",
            pt: "Entrar",
            es: "Iniciar sesión",
            ru: "Войти",
            tr: "Giriş yap",
        },
        signupTitle: {
            en: "Create free account",
            pt: "Criar conta grátis",
            es: "Crear cuenta gratis",
            ru: "Создать бесплатный аккаунт",
            tr: "Ücretsiz hesap oluştur",
        },
        email: {
            en: "Email",
            pt: "E-mail",
            es: "Correo",
            ru: "E-mail",
            tr: "E-posta",
        },
        password: {
            en: "Password",
            pt: "Senha",
            es: "Contraseña",
            ru: "Пароль",
            tr: "Şifre",
        },
    },
    footer: {
        platforms: {
            en: "Platforms",
            pt: "Plataformas",
            es: "Plataformas",
            ru: "Платформы",
            tr: "Platformlar",
        },
        resources: {
            en: "Resources",
            pt: "Recursos",
            es: "Recursos",
            ru: "Ресурсы",
            tr: "Kaynaklar",
        },
        company: {
            en: "Company",
            pt: "Empresa",
            es: "Empresa",
            ru: "Компания",
            tr: "Şirket",
        },
        rights: {
            en: "All rights reserved.",
            pt: "Todos os direitos reservados.",
            es: "Todos los derechos reservados.",
            ru: "Все права защищены.",
            tr: "Tüm hakları saklıdır.",
        },
    },
};
